<div class="row">
    <div class="col-md-12" *ngIf="form">
        <form class="row" [formGroup]="form">
            <div class="col-md-4">
                <mat-form-field appearance="standard">
                    <input type="text" matInput formControlName="nomenclature" [matAutocomplete]="auto"
                        placeholder="Dirección">
                    <mat-autocomplete #auto="matAutocomplete">
                        <mat-option *ngFor="let nomenclature of nomenclatureListAsync | async" [value]="nomenclature">
                            {{nomenclature}}
                        </mat-option>
                    </mat-autocomplete>
                </mat-form-field>
            </div>

            <div class="col-md-2">
                <div class="row">
                    <mat-form-field appearance="standard">
                        <input matInput type="text" placeholder="00" formControlName="mainRoad" class="text-center">
                    </mat-form-field>
                </div>
            </div>

            <div class="pad">
                #
            </div>

            <div class="col-md-2">
                <div class="row">
                    <mat-form-field appearance="standard">
                        <input matInput type="text" placeholder="00" formControlName="secundaryRoad"
                            class="text-center">
                    </mat-form-field>
                </div>
            </div>

            <div class="pad">
                -
            </div>

            <div class="col-md-2">
                <div class="row">
                    <mat-form-field appearance="standard">
                        <input matInput type="text" placeholder="00" formControlName="complementaryRoad"
                            class="text-center">
                    </mat-form-field>
                </div>
            </div>
        </form>
        <div class="row">
            <div class="col-md-12">
                <span class="pattern pattern--invalid" *ngIf="form.invalid">
                    Dirección invalida
                </span>
            </div>
        </div>
    </div>
</div>